import { Stack } from '@mui/material'

import FilterBar from './FilterBar/FilterBar'
import InfoBar from './InfoBar/InfoBar'
import KPIBar from './KPIBar/KPIBar'
import ProgressBar from './ProgressBar/ProgressBar'

type Props = {
	children: React.ReactNode
}

// Header height depends on the status of the market basket (completed vs processing/failed/pending)
const completedHeaderHeight = '8.25rem'
const processingHeaderHeight = '11.25rem'

function BasketHeader({ children }: Props) {
	return <Stack gap={1}>{children}</Stack>
}

BasketHeader.InfoBar = InfoBar
BasketHeader.KPIBar = KPIBar
BasketHeader.FilterBar = FilterBar
BasketHeader.ProgressBar = ProgressBar

export default BasketHeader
export { completedHeaderHeight, processingHeaderHeight }
